// helpers/displayCurrency.js

const displayINRCurrency = (amount) => {
    if (!amount) return "";
    // Convert the number to a string with commas and prefix with "Rs "
    return `Rs ${amount.toLocaleString("en-IN")}`;
}

export default displayINRCurrency;
